import {styled, makeStyles, Box, TextareaAutosize, InputUnstyled, Checkbox} from 'external/material'

const useStyles = makeStyles(homeworkBodyStyles)
const ScoreField = styled(InputUnstyled)(scoreStyles)

export default function HomeworkFeedback({context, studentFeedback, updateFeedback, homework, homeworkStatus}) {

    const {translate} = context
    const classes = useStyles()

    function createHandler(prop, mapper = e => e.target.value) {
        return (e) => {
            updateFeedback(studentFeedback.id, prop, mapper(e))
        }
    }
 
    return (
        <>
            <Box className={classes.scoreField}>
              <ScoreField
                type="number"
                className="scoreTextBox"
                onKeyDown={e => {
                  if (/\d/.test(e.key)) return
                  if (e.key == '.' && e.target.value.indexOf('.') < 0) return
                  if (e.key.length > 1) return
                  e.preventDefault()
                }}
                value={studentFeedback.score}
                onChange={createHandler('score')}
                />
                <div>/ {homework.properties.score}</div>
            </Box>
            <Box className={classes.feedbackBox}>
                {homeworkStatus != 'expired' && (<Box>
                    <Checkbox                        
                    checked={studentFeedback.returned}
                    onChange={createHandler('returned', ()=> !studentFeedback.returned)}                      
                    />
                    <label>{translate('homework-return')}</label>
                </Box>)}
                <TextareaAutosize
                    className={classes.feedbackText}                      
                    rows={2}
                    maxRows={4}
                    placeholder={translate('feedback-header')}
                    value={studentFeedback.message}
                    onChange={createHandler('message')}
                    />
            </Box>
        </>
    )
    }

function scoreStyles (){
  return {
     "&.scoreTextBox input": {
          width: 70,
          height: 30,
          border: '1px solid #ccc',
          marginRight: 15,
          textAlign: 'center',
          padding: '0 5px',
          borderRadious: 4
        },
  }
}
   
function homeworkBodyStyles() {
    return {
        scoreField: {
          fontSize: '14pt',
          fontWeight: 'bold',
          display: 'flex',
          "& > div": {
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center'
          }
        },
        feedbackBox: {
          display: 'block',
          margin: '10px 0',
          backgroundColor: '#e8e8e8',
          padding: 5,
          borderRadius: 3,
          '& label': {
            fontSize: '12px'
          }
        },
        feedbackText: {
          fontSize: '12px',
          fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
          padding: 10,
          borderRadius: 4,
          border: '1px solid #ccc',
          width: '100%'
        }
      };
}
